import { Route, BrowserRouter as Router, Switch } from "react-router-dom";
import {
  authLayoutRoutes,
  dashboardLayoutRoutesAdmin,
  dashboardLayoutRoutesEmployee,
  dashboardLayoutRoutesExternalUser,
  dashboardLayoutRoutesManager,
  dashboardLayoutRoutesViewer,
} from "./index";

import AuthLayout from "../layouts/Auth";

// import Page404 from "../pages/auth/Page404";
import Page404 from "../components/GovGr404Page";

import React from "react";
import { useSelector } from "react-redux";
import GovGrDrawerMenu from "../components/GovGrDrawerMenu";
import GovGrLayout from "../components/GovGrLayout";
import GovGrLoader from "../components/GovGrLoader";
import GovGrLayoutExternalUser from "../components/GovGrLayoutExternalUser";

const childRoutes = (Layout, routes) =>
  routes.map(({ component: Component, guard, children, path }, index) => {
    const Guard = guard || React.Fragment;

    return children ? (
      children.map((element, index) => {
        const Guard = element.guard || React.Fragment;
        const ElementComponent = element.component || React.Fragment;

        return (
          <Route
            key={index}
            path={element.path}
            exact
            render={(props) => (
              <Layout>
                <Guard>
                  <ElementComponent {...props} />
                </Guard>
              </Layout>
            )}
          />
        );
      })
    ) : Component ? (
      <Route
        key={index}
        path={path}
        exact
        render={(props) => (
          <Layout>
            <Guard>
              <Component {...props} />
            </Guard>
          </Layout>
        )}
      />
    ) : null;
  });

const Routes = () => {
  const auth_level = useSelector(
    (state) => state?.authReducer?.user?.auth_level
  );



  const aa = () => {
    // console.log("auth_level " + auth_level);
  }




  return (
    <Router>
      {aa()};
      <Switch>
        {auth_level === 0 &&
          childRoutes(GovGrLayout, dashboardLayoutRoutesAdmin)}
        {auth_level === 1 &&
          childRoutes(GovGrLayout, dashboardLayoutRoutesManager)}
        {auth_level === 2 &&
          childRoutes(GovGrLayout, dashboardLayoutRoutesEmployee)}
        {auth_level === 3 &&
          childRoutes(
            // DashboardLayout
            GovGrLayoutExternalUser,
            dashboardLayoutRoutesExternalUser
          )}
        {auth_level === 4 &&
          childRoutes(
            // DashboardLayout
            GovGrLayout,
            dashboardLayoutRoutesViewer
          )}
        {childRoutes(AuthLayout, authLayoutRoutes)}
        <Route
          render={() => (
            <AuthLayout>
              <GovGrDrawerMenu apptitle="E-θυρίδα Ναυτικού" hiddenmenu={true}>
                {/* {auth_level ? */}
                <Page404 />
                {/* <GovGrLoader />} */}
              </GovGrDrawerMenu>
            </AuthLayout>
          )}
        />
      </Switch>
    </Router>
  );
};

export default Routes;
